import React, { Component } from 'react';
import { connect } from 'react-redux';
import style from './style.css';
import ReactS3Uploader from 'react-s3-uploader';
import config from '../../config';
import { Loader } from 'semantic-ui-react';

class AmazonObjectCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploading: false,
      uploadDone: false,
    };
  }

  onUploadProgress = () => {
    this.setState({ uploading: true });
    this.props.onStart();
  };
  onUploadFinish = (result) => {
    this.props.onFinish(result);
    this.setState({ uploading: false });
    this.setState({ uploadDone: true });
  };
  randomString = () => {
    return new Date().getTime().toString(36);
  };

  render() {
    const { uploading } = this.state;
    const headers = { 'Access-Control-Allow-Origin': '*' };
    let fileName = '';
    if (this.props.filename) {
      fileName = this.props.filename;
    } else {
      fileName = this.randomString();
    }
    return (
      <div className='amazonObject'>
        <ReactS3Uploader
          signingUrl='/amazon/post/sign'
          signingUrlMethod='GET'
          accept='image/*'
          preprocess={this.onUploadStart}
          onProgress={this.onUploadProgress}
          onError={this.onUploadError}
          onFinish={(result) => this.onUploadFinish(result)}
          signingUrlHeaders={{ additional: headers }}
          signingUrlQueryParams={{
            directoryPath: this.props.directoryPath,
            filename: fileName,
          }}
          signingUrlWithCredentials={true}
          uploadRequestHeaders={{ 'x-amz-acl': 'public-read' }}
          server={config.apiHost}
        />
        {this.props.children}
        {uploading && (
          <span className='loader-container'>
            <Loader size='small' active />
          </span>
        )} 
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(AmazonObjectCreate);



// WEBPACK FOOTER //
// ./src/components/AmazonObjectCreate/AmazonObjectCreate.js